import { ENVIRONMENT } from 'OpsCenter/app.constants';

(function(window, undefined) {
  /**
   * author andre.pitombeira
   */
  (function() {
    'use strict';
    angular
      .module('ec.util', [])
      .constant('HTTP_CODE', {
        STATUS: {
          NO_CONNECTION: 0,
          OK: 200,
          CREATED: 201,
          NO_CONTENT: 204,
          BAD_REQUEST: 400,
          UNAUTHORIZED: 401,
          FORBIDDEN: 403,
          NOT_FOUND: 404,
          CONFLICT: 409,
          INTERNAL_SERVER_ERROR: 500,
          SERVICE_UNAVAILABLE: 503,
        },
      })
      .constant('EVENTS', {
        SHOW_BUTTERBAR: 'ui-butterbar.show',
        HIDE_BUTTERBAR: 'ui-butterbar.hide',
      })
      .constant('ERROR_MSG', {
        NO_CONNECTION: 'No connection. Verify your internet connection.',
        BAD_REQUEST: 'Bad Request.',
        UNAUTHORIZED: 'Unauthorized.',
        FORBIDDEN: 'Forbidden.',
        NOT_FOUND: 'Not Found.',
        CONFLICT: 'Conflict.',
        INTERNAL_SERVER_ERROR: 'Internal Server Error.',
        SERVICE_UNAVAILABLE: 'Service Unavailable.',
      })
      .constant('API_TOKEN', {
        header: 'X-Quandoo-Authtoken',
      });
  })();
  /**
   * author andre.pitombeira
   *
   * Obs: get the $http via $injector because of circular dependency problem
   */
  (function() {
    'use strict';
    angular.module('ec.util').factory('LoadingInterceptor', LoadingInterceptor);

    /** @ngInject **/
    function LoadingInterceptor($injector, $rootScope, $q, EVENTS) {
      var service;
      service = {
        request: request,
        requestError: requestError,
        response: response,
        responseError: responseError,
      };
      return service;

      function request(config) {
        $rootScope.$broadcast(EVENTS.SHOW_BUTTERBAR);
        return config;
      }

      function requestError(rejection) {
        if ($injector.get('$http').pendingRequests.length < 1) {
          $rootScope.$broadcast(EVENTS.HIDE_BUTTERBAR);
        }
        return $q.reject(rejection);
      }

      function response(res) {
        if ($injector.get('$http').pendingRequests.length < 1) {
          $rootScope.$broadcast(EVENTS.HIDE_BUTTERBAR);
        }
        return res || $q.when(res);
      }

      function responseError(rejection) {
        if ($injector.get('$http').pendingRequests.length < 1) {
          $rootScope.$broadcast(EVENTS.HIDE_BUTTERBAR);
        }
        return $q.reject(rejection);
      }
    }

    LoadingInterceptor.$inject = ['$injector', '$rootScope', '$q', 'EVENTS'];
  })();
  /**
   * author andre.pitombeira
   */
  (function() {
    'use strict';
    angular.module('ec.util').factory('NotificationInterceptor', NotificationInterceptor);

    /** @ngInject **/
    function NotificationInterceptor($q, NotificationService, HTTP_CODE, ERROR_MSG) {
      var service;
      service = {
        responseError: responseError,
      };
      return service;

      function responseError(response) {
        var status = response.status,
          ignoreStatus = response.config.ignoreStatus,
          statusCodes = HTTP_CODE.STATUS;
        if (status === statusCodes.NO_CONNECTION && status !== ignoreStatus) {
          NotificationService.error(ERROR_MSG.NO_CONNECTION);
        } else {
          if (status === statusCodes.UNAUTHORIZED && status !== ignoreStatus) {
            NotificationService.error(ERROR_MSG.UNAUTHORIZED);
          } else {
            if (status === statusCodes.FORBIDDEN && status !== ignoreStatus) {
              NotificationService.error(ERROR_MSG.FORBIDDEN);
            } else {
              if (status === statusCodes.NOT_FOUND && status !== ignoreStatus) {
                NotificationService.error(ERROR_MSG.NOT_FOUND);
              } else {
                if (status === statusCodes.INTERNAL_SERVER_ERROR && status !== ignoreStatus) {
                  NotificationService.error(ERROR_MSG.INTERNAL_SERVER_ERROR);
                } else {
                  if (status === statusCodes.SERVICE_UNAVAILABLE && status !== ignoreStatus) {
                    NotificationService.error(ERROR_MSG.SERVICE_UNAVAILABLE);
                  }
                }
              }
            }
          }
        }
        return $q.reject(response);
      }
    }

    NotificationInterceptor.$inject = ['$q', 'NotificationService', 'HTTP_CODE', 'ERROR_MSG'];
  })();
  (function() {
    'use strict';
    angular.module('ec.util').factory('environmentService', environmentService);

    /** @ngInject */
    function environmentService($location, ENVIRONMENT) {
      var service,
        environment = setEnvironment();
      service = {
        getEnvironment: getEnvironment,
        setEnvironment: setEnvironment,
        isBetaOrProduction: isBetaOrProduction,
      };
      return service;

      function isBetaOrProduction() {
        return [ENVIRONMENT.BETA[0], ENVIRONMENT.LIVE[0]].includes($location.host());
      }

      function getEnvironment() {
        return environment;
      }

      function setEnvironment() {
        if (window.ENVIRONMENT.API_URI) {
          environment = {
            OC_API: window.ENVIRONMENT.API_URI,
            BC_API: window.ENVIRONMENT.BC_URI,
          };
        }
        var host = $location.host();
        switch (host) {
          case ENVIRONMENT.LOCAL[0]:
            environment = {
              OC_API: ENVIRONMENT.LOCAL[1],
              BC_API: ENVIRONMENT.LOCAL[2],
            };
            break;
          case ENVIRONMENT.IQA[0]:
            environment = {
              OC_API: ENVIRONMENT.IQA[1],
              BC_API: ENVIRONMENT.IQA[2],
            };
            break;
          case ENVIRONMENT.IWEB[0]:
            environment = {
              OC_API: ENVIRONMENT.IWEB[1],
              BC_API: ENVIRONMENT.IWEB[2],
            };
            break;
          case ENVIRONMENT.TEST[0]:
            environment = {
              OC_API: ENVIRONMENT.TEST[1],
              BC_API: ENVIRONMENT.TEST[2],
            };
            break;
          case ENVIRONMENT.BETA[0]:
            environment = {
              OC_API: ENVIRONMENT.BETA[1],
              BC_API: ENVIRONMENT.BETA[2],
            };
            break;
          case ENVIRONMENT.LIVE[0]:
            environment = {
              OC_API: ENVIRONMENT.LIVE[1],
              BC_API: ENVIRONMENT.LIVE[2],
            };
            break;
          default:
            environment = {
              OC_API: ENVIRONMENT.IWEB[1],
              BC_API: ENVIRONMENT.IWEB[2],
            };
        }
        return Object.assign(environment, {GOOGLE_CLIENT_ID: window.ENVIRONMENT.GOOGLE_SIGN_IN_CLIENT_ID});
      }
    }

    environmentService.$inject = ['$location', 'ENVIRONMENT'];
  })();
  /**
   * author andre.pitombeira
   */
  (function() {
    'use strict';
    angular.module('ec.util').factory('localStorageService', localStorageService);

    /** @ngInject */
    function localStorageService($window, $cookies) {
      var service,
        localStorageSupported = true;
      try {
        $window.localStorage.test = 1;
      } catch (e) {
        localStorageSupported = false;
      }
      service = {
        storeValue: storeValue,
        getValue: getValue,
      };
      return service;

      function storeValue(key, value) {
        localStorageSupported ? $window.localStorage.setItem(key, value) : $cookies.put(key, value);
      }

      function getValue(key) {
        return localStorageSupported ? $window.localStorage.getItem(key) : $cookies.get(key);
      }
    }

    localStorageService.$inject = ['$window', '$cookies'];
  })();
  (function() {
    'use strict';
    angular.module('ec.util').factory('paginationService', paginationService);

    /** @ngInject **/
    function paginationService() {
      function getNumberOfPagesLeft(data, total) {
        var len;
        if (!data || !total) {
          return 0;
        }
        len = data.length;
        return len > 0 ? Math.ceil(total / len - 1) : 0;
      }

      return {
        getNumberOfPagesLeft: getNumberOfPagesLeft,
      };
    }
  })();
  /**
   * author andre.pitombeira
   */
  (function() {
    'use strict';
    angular.module('ec.util').factory('UtilService', UtilService);

    /** @ngInject **/
    function UtilService() {
      var service;
      service = {
        findElementPositionById: findElementPositionById,
        findElementPositionByName: findElementPositionByName,
        findElementById: findElementById,
        findElementByName: findElementByName,
        deleteElementById: deleteElementById,
        toggleElementFromArray: toggleElementFromArray,
        removeNonNumericValues: removeNonNumericValues,
        updateObjectInListByProperty: updateObjectInListByProperty,
        generateSearchUrl: generateSearchUrl,
        generateRange: generateRange,
        generateNumericRange: generateNumericRange,
        parseTextByNonNumericCharacter: parseTextByNonNumericCharacter,
        isNumeric: isNumeric,
        getObjectKeyByValue: getObjectKeyByValue,
      };
      return service;

      function findElementPositionById(arr, id) {
        if (!(arr && arr.length && id)) {
          return;
        }
        return arr
          .map(function(element) {
            return element.id;
          })
          .indexOf(id);
      }

      function deleteElementById(arr, id) {
        var elementPosition = service.findElementPositionById(arr, id);
        return elementPosition >= 0 ? arr.splice(elementPosition, 1) : elementPosition;
      }

      function findElementById(arr, id) {
        var elementPosition = service.findElementPositionById(arr, id);
        return elementPosition >= 0 ? arr[elementPosition] : elementPosition;
      }

      function findElementPositionByName(arr, name) {
        if (!(arr && arr.length && name)) {
          return null;
        }
        for (var i = 0, len = arr.length; i < len; i++) {
          if (arr[i].name === name) {
            return i;
          }
        }
        return null;
      }

      function findElementByName(arr, name) {
        var position = findElementPositionByName(arr, name);
        if (position !== null && position >= 0) {
          return arr[position];
        }
        return null;
      }

      function toggleElementFromArray(arr, element) {
        if (!(arr && element)) {
          return;
        }
        var index = arr.indexOf(element);
        index >= 0 ? arr.splice(index, 1) : arr.push(element);
      }

      /**
       * @name removeNonNumericValues
       * @desc Cleans a numeric array of non numeric values.
       * @example [0, 1, 2, "3", null, "", undefined, "another string", {object:1}, NaN]; -> [0,1,2,"3"]
       * @reference https://github.com/jquery/jquery/blob/c869a1ef8a031342e817a2c063179a787ff57239/src/core.js#L214
       * @param inputArray
       * @returns {*}
       */
      function removeNonNumericValues(inputArray) {
        if (!(inputArray && inputArray.length)) {
          return inputArray;
        }
        return inputArray.filter(isNumeric);
      }

      function isNumeric(el) {
        return el - parseFloat(el) + 1 >= 0;
      }

      function updateObjectInListByProperty(list, obj, prop) {
        if (!(list && list.length && (obj && prop))) {
          return;
        }
        for (var i = 0, len = list.length; i < len; i++) {
          if (list[i].hasOwnProperty(prop) && obj.hasOwnProperty(prop) && list[i][prop] === obj[prop]) {
            list[i] = obj;
          }
        }
        return list;
      }

      function generateSearchUrl(filter) {
        var hasParam = false,
          url = '',
          param = '',
          prop;
        if (!filter) {
          return url;
        }
        for (prop in filter) {
          if (filter.hasOwnProperty(prop) && filter[prop]) {
            if (!hasParam) {
              hasParam = true;
              url += '?';
            }
            if (param) {
              url += '&';
              param = '';
            }
            param += prop;
            param += '=';
            param += encodeURIComponent(filter[prop]);
            url += param;
          }
        }
        return url;
      }

      function generateRange(text, maxValue) {
        var i = 1,
          obj,
          arr = [];
        if (!maxValue) {
          return arr;
        }
        if (!text) {
          return new Array(maxValue);
        }
        for (i; i <= maxValue; i++) {
          obj = {
            name: text + ' ' + i,
            value: i,
          };
          arr.push(obj);
        }
        return arr;
      }

      function generateNumericRange(minValue, maxValue, limit, step) {
        var result = [],
          i;
        step = step || 1;
        if (limit) {
          maxValue = maxValue > limit ? limit : maxValue;
        }
        for (i = minValue; i <= maxValue; i += step) {
          result.push(i);
        }
        return result;
      }

      function parseTextByNonNumericCharacter(text) {
        if (!text) {
          return;
        }
        return service.removeNonNumericValues(text.trim().split(/[^\d]+/g));
      }

      function getObjectKeyByValue(obj, val) {
        return (
          Object.keys(obj).filter(function(key) {
            return angular.equals(obj[key], val);
          })[0] || null
        );
      }
    }
  })();
})(window, undefined);



// WEBPACK FOOTER //
// ./src/app/vendor/ec-fe-bo-template/dist/util/util.max.js